import { useEffect } from "react";

interface Options {
  selectedIndex: number | null;
  fieldCount: number;
  onSwap: (fromIndex: number, toIndex: number) => void;
}

export default function useKeyboardReorder({ selectedIndex, fieldCount, onSwap }: Options) {
  useEffect(() => {
    if (selectedIndex == null) return undefined;

    const handler = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey)) return;
      if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
      // Cmd+Arrow is native caret navigation inside inputs and the Trix editor.
      const origin = e.target as HTMLElement | null;
      if (origin?.closest("input, textarea, select, [contenteditable=true], trix-editor")) return;
      e.preventDefault();

      const target = selectedIndex + (e.key === "ArrowUp" ? -1 : 1);
      if (target < 0 || target >= fieldCount) return;

      onSwap(selectedIndex, target);
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [selectedIndex, fieldCount, onSwap]);
}
